import angular from 'angular';
import HeaderNavigationService from "./headernavigation-service";
import HeaderNavigationController from "./headernavigation-controller";


let HeaderNavigation = angular
    .module('HeaderNavigation', [])
    .controller('HeaderNavigationController', HeaderNavigationController)
    .service('HeaderNavigationService', HeaderNavigationService);

export default HeaderNavigation;

